import { render, staticRenderFns } from "./industryTab2.vue?vue&type=template&id=3d0596c4&scoped=true"
import script from "./industryTab2.vue?vue&type=script&lang=js"
export * from "./industryTab2.vue?vue&type=script&lang=js"
import style0 from "./industryTab2.vue?vue&type=style&index=0&id=3d0596c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0596c4",
  null
  
)

export default component.exports